<template>
  <div class="products-chip-filter">
    <div class="products-chip-head">
      <b-icon icon="award"></b-icon>
      <strong>برند</strong>
      <input class="products-chip-search" v-model="brandQuery" placeholder="جستجوی برند">
    </div>
    <div class="products-chip-list">
      <button
        v-for="brand in filteredBrands"
        :key="brand.id"
        type="button"
        class="products-chip"
        :class="{ 'is-on': isSelected(brand.id) }"
        @click="toggleBrand(brand.id)"
      >
        {{ brand.name }}
      </button>
      <p v-if="!filteredBrands.length" class="products-chip-empty mb-0">برندی پیدا نشد.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Brand",
  data() {
    return {
      brands: [],
      selectedBrand: [],
      brandQuery: '',
      ready: false,
    }
  },
  computed: {
    filteredBrands() {
      const query = (this.brandQuery || '').trim()
      if (!query) {
        return this.brands
      }
      return this.brands.filter(brand => (brand.name || '').indexOf(query) > -1)
    }
  },
  methods: {
    isSelected(id) {
      return this.selectedBrand.some(item => String(item) === String(id))
    },
    toggleBrand(id) {
      const index = this.selectedBrand.findIndex(item => String(item) === String(id))
      if (index > -1) {
        this.selectedBrand.splice(index, 1)
      } else {
        this.selectedBrand.push(id)
      }
    },
    applyFilter() {
      if (!this.ready) {
        return
      }
      this.$store.commit("Product/setFilters", {key: "brand", value: this.selectedBrand});
      this.$emit('updateFilter', {brand: this.selectedBrand})
      this.$store.dispatch("Product/setDashboardProducts", 1);
    }
  },
  async mounted() {
    let value = this.$route.query.brand;
    if (value != undefined) {
      this.selectedBrand = value.split(',').filter(Boolean)
      this.$store.commit('Product/setFilters', {key: 'brand', value: this.selectedBrand})
    }

    const response = await this.$store.dispatch('Brand/getBrandsWithoutPagination')
    this.brands = (response && response.data && response.data.data) || []
    this.$nextTick(() => {
      this.ready = true
    })
  },
  watch: {
    selectedBrand: {
      deep: true,
      handler() {
        this.applyFilter()
      }
    }
  },
  destroyed() {
    this.$store.commit("Product/setFilters", {key: "brand", value: []});
  }
}
</script>
